import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/shared/services/api";
import type { ApiResponse } from "@/features/auth/services/authApi";

export interface UnitOfMeasure {
    value: number;
    name: string;
    category: string;
    abbreviation: string;
    description: string;
}

export const useUnitsOfMeasure = () => {
    return useQuery({
        queryKey: ["units-of-measure"],
        queryFn: async () => {
            const {data} = await apiClient.get<ApiResponse<UnitOfMeasure[]>>(
                "/Metadata/units-of-measure"
            );

            const units = data.data || [];

            // Dedupe by `value` because the API may return duplicate entries
            const deduped = Array.from(new Map(units.map((u) => [u.value, u])).values());

            return deduped;
        },
    });
};